import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ChatCircleDots, Star } from "@phosphor-icons/react";

export default function GovAvaliacoes() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/reviews"); setRows(Array.isArray(data) ? data : (data?.items || [])); }
      catch { setRows([]); }
      finally { setLoading(false); }
    })();
  }, []);
  const avg = rows.length ? (rows.reduce((s, r) => s + (r.rating || 0), 0) / rows.length) : 0;

  return (
    <div data-testid="gov-avaliacoes-page">
      <div className="mb-6">
        <div className="text-[10px] uppercase tracking-[0.22em] text-emerald-700/70 font-medium mb-1">Atendimento</div>
        <h1 className="font-heading text-2xl font-semibold text-slate-900 tracking-tight flex items-center gap-2">
          <ChatCircleDots size={22} className="text-emerald-700" />
          Satisfação do Cidadão
        </h1>
        <p className="text-[12.5px] text-slate-500 mt-0.5">CSAT dos atendimentos · pesquisa pós-conversa automática.</p>
      </div>
      <div className="grid gap-3 md:grid-cols-4 mb-6">
        <StatCard label="Média geral" value={avg.toFixed(1)} suffix="⭐" />
        <StatCard label="Avaliações" value={rows.length} />
        <StatCard label="Muito satisfeito" value={rows.filter(r => (r.rating || 0) >= 4).length} />
        <StatCard label="Insatisfeito" value={rows.filter(r => (r.rating || 0) <= 2).length} />
      </div>
      <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">
        {loading && <div className="p-8 text-center text-slate-400 text-[12.5px]">Carregando…</div>}
        {!loading && rows.length === 0 && (
          <div className="p-10 text-center text-[13px] text-slate-500">
            <Star size={28} className="mx-auto mb-2 text-slate-300" />
            Nenhuma avaliação registrada ainda.
          </div>
        )}
        {!loading && rows.length > 0 && (
          <ul className="divide-y divide-slate-100">
            {rows.map(r => (
              <li key={r.id} className="p-4">
                <div className="flex items-center gap-2 mb-1">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star key={i} size={12} weight={i < (r.rating || 0) ? "fill" : "regular"} className={i < (r.rating || 0) ? "text-amber-400" : "text-slate-300"} />
                  ))}
                  <span className="text-[11.5px] text-slate-500 ml-2">{r.customer_name || "Cidadão"}</span>
                </div>
                {r.comment && <div className="text-[12.5px] text-slate-700 italic">&ldquo;{r.comment}&rdquo;</div>}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
function StatCard({ label, value, suffix }) {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-3">
      <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-1">{label}</div>
      <div className="text-[22px] font-semibold text-slate-900 tabular-nums">
        {value}{suffix && <span className="text-[14px] ml-1">{suffix}</span>}
      </div>
    </div>
  );
}
